import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';
import breakpoints from '../../shared/breakpoints';

const TYPES = [
  'Cash', 'Equities', 'Fixed Income', 'Managed Fund (Aust.)',
  'Managed Fund (Global)', 'Property', 'Unlisted Investments',
];

const Input = ({ label }) => {
  const kebab = _.kebabCase(label);
  return (
    <label className="btn btn-default" htmlFor={kebab}>
      <input id={kebab} type="checkbox" name="investorType" autoComplete="off" value={kebab.replace('-', '_')} />
      {` ${label}`}
    </label>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
};

export default class StyleGuideLivewireWizardStepModal extends React.Component {
  componentDidMount() {
    postal.subscribe({
      channel: 'commands.style-guide-livewire-wizard-step-modal',
      topic: 'present',
      callback: () => this.present(),
    });
  }

  present() {
    breakpoints.upFrom_medium() && this.$overlay.fadeIn(400);
    this.$modal.fadeIn(400);
  }

  dismiss() {
    breakpoints.upFrom_medium() && this.$overlay.fadeOut(400);
    this.$modal.fadeOut(400);
  }

  render() {
    return (
      <div>
        <div
          ref={el => (this.$overlay = $(el))}
          role="region"
          className="livewire-modal-overlay style-guide-livewire-wizard-step-modal-overlay"
          onClick={() => this.dismiss()}
        />
        <div
          ref={el => (this.$overlay = $(el))}
          className="livewire-modal style-guide-livewire-wizard-step-modal"
          tabIndex="-1"
          role="dialog"
        >
          <article>
            <header>
              <button type="button" className="close-modal" onClick={() => this.dismiss()}>
                <span className="pe-7s-close pe-icon-x3" />
                <span className="sr-only">Close</span>
              </button>
              <p className="step">Step 3 of 5</p>
              <h4>Which investment themes are you most interested in?</h4>
            </header>
            <section>
              <p className="step-instructions">
                Select the asset classes which relate to your investment portfolio.
              </p>
              <form onSubmit={() => this.dismiss()}>
                <div className="btn-group">
                  {TYPES.map(type => <Input label={type} key={type} />)}
                </div>
                <p className="has-error">
                  <span className="help-block">Please select your investment theme interests</span>
                </p>
                <p className="form-group">
                  <button type="submit" className="btn btn-primary">Continue</button>
                </p>
              </form>
            </section>
          </article>
        </div>
      </div>
    );
  }
}
